import React from 'react';
import './ShopBtn.sass';

const ShopBtn = ({href, icon, type, description}) => {
    return (
        <div className="shop-btn">
            <a
                href={href}
                className="shop-btn-link"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={icon} alt=""/>
            </a>
            <span className="shop-btn-description">{description}</span>
        </div>
    );
};

export default ShopBtn;
